import { missionFilesState } from './missionsFilesSlice';

export const initialState: missionFilesState = {
  loading: 'idle',
  data: [],
};
